const initalizePendo = (account) => {
  const temp = setInterval(() => {
    const pendo = window?.pendo;
    if (!pendo) return;

    pendo.initialize({
      visitor: {
        surveyName: account.surveyName,
        isKiosk: account.isKiosk,
      },
      account: {
        id: account.companyId,
        name: account.companyName,
      },
    });

    clearInterval(temp);
  }, 300);
};

export { initalizePendo };
